'use client'
import { ContainerCustom, Image } from '@/components'
import { COMMON_SPACING_SECTION } from '@/constants'
import { Box, Typography } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import HTMLReactParser from 'html-react-parser/lib/index'

gsap.registerPlugin(ScrollTrigger)

type Props = {
  content?: {
    title_1: string
    title: string
    title_2?: string
    list?: { title: string; des: string; src: string }[]
  }
}

export const Trend = ({ content }: Props) => {
  console.log('cotntent', content)

  const boxesRef = React.useRef<any[]>([])

  useEffect(() => {
    // góc xoay tương ứng với từng item
    const rotations = [18, -16.3866, 1.54242]

    boxesRef.current.forEach((box, index) => {
      if (!box) return

      gsap.fromTo(
        box,
        {
          scale: 1.2,
          rotateZ: 0,
          transformOrigin: 'center center',
        },
        {
          scale: 1,
          rotateZ: rotations[index] || 0,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: box,
            start: 'top center',
            end: 'bottom center',
            scrub: true,
          },
        }
      )
    })
  }, [])

  return (
    <Box sx={{ py: COMMON_SPACING_SECTION, backgroundColor: '#F4F5F8', mt: COMMON_SPACING_SECTION }}>
      <ContainerCustom>
        <Box sx={{ minHeight: '200vh', flexDirection: 'column', display: 'flex', gap: '10em' }}>
          <Box
            sx={{
              position: 'sticky',
              top: '10vh',
              mx: 'auto',
              textAlign: 'center',
              maxWidth: '66em',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              gap: '1em',
              minHeight: '50vh',
              fontSize: { xs: '1.8vw', md: '1.4vw', lg: '1em' },
            }}
          >
            <Typography sx={{ fontSize: '1.5em', fontWeight: 600 }}>
              {HTMLReactParser(content?.title_1 || '')}
            </Typography>
            <Typography variant="h2" sx={{ fontSize: '3.5em', fontWeight: 600 }}>
              {HTMLReactParser(content?.title || '')}
            </Typography>
            <Typography sx={{ fontSize: '1.3em', fontWeight: 300, mx: 'auto', maxWidth: '25em' }}>
              {HTMLReactParser(content?.title_2 || '')}
            </Typography>
          </Box>

          {content?.list?.map((item, index) => (
            <Box
              key={index}
              component={'div'}
              ref={(el: any) => (boxesRef.current[index] = el!)}
              sx={{
                position: 'sticky',
                top: '20vh',
                width: '32em',
                maxWidth: '80%',
                mx: 'auto',
                borderRadius: '1em',
                overflow: 'hidden',
                background: '#fff',
                transformStyle: 'preserve-3d',
              }}
            >
              <Box sx={{ aspectRatio: 1 / 1, background: '#51504E' }}>
                {item?.src && (
                  <Image
                    src={item.src}
                    alt={item.title}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 1,
                  p: '1em',
                }}
              >
                <Typography sx={{ fontWeight: 600 }}>{item?.title}</Typography>
                <Typography>{item?.des}</Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </ContainerCustom>
    </Box>
  )
}
